import React from 'react';
import cn from 'classnames';
import { formatDataAmount } from 'helpers/formatters';
import styles from './DataMeter.module.css';

const DataMeter = ({ oldAvail, newAvail, mbUsed, isUnlimited }) => {
  let remaining = oldAvail - mbUsed;
  if (remaining <= 0) { remaining = 0; }
  const adding = newAvail - oldAvail;

  const [used, usedUnit] = formatDataAmount(mbUsed);
  const [old, oldUnit] = formatDataAmount(oldAvail);
  const [newData, newUnit] = formatDataAmount(adding);

  let usedWidth, oldWidth, newWidth;
  let percentBase = 100;
  let usedTextShift = 0;

  if (adding === 0) {
    newWidth = 5;
    percentBase = percentBase - 5;
  }
  if (mbUsed === 0) {
    usedWidth = 5;
    percentBase = percentBase - 5;
  }
  if (isUnlimited) {
    oldWidth = 5;
    usedWidth = 5;
    newWidth = 90;
  }

  if (oldWidth === undefined) {
    oldWidth = (remaining / newAvail) * percentBase;
  }
  if (usedWidth === undefined) {
    usedWidth = (mbUsed / newAvail) * percentBase;
    if (usedWidth <= 5) {
      usedTextShift = 30;
    }
  }
  if (newWidth === undefined) {
    newWidth = (adding / newAvail) * percentBase;
  }
  
  return (
    <div className={styles.DataMeter}>
      <div style={{ width: usedWidth + '%' }} className={cn(styles.used, styles.segment)}>
        <div style={{ paddingLeft: usedTextShift + 'px' }} className={styles.label}>
          {used}{usedUnit} used
        </div>
      </div>
      <div style={{width: oldWidth + '%'}} className={cn(styles.plan, styles.segment)}>
        <div className={styles.label}>
          {old}{oldUnit} plan
        </div>
      </div>
      <div style={{width: newWidth + '%'}} className={cn(styles.add, styles.segment)}>
        {isUnlimited ? (
          <div className={styles.label}>
            add unlimited data
          </div>
        ) : (
          <div className={styles.label}>
            add {newData}{newUnit}
          </div>
        )}
      </div>
    </div>
  )
}

export default DataMeter;
